import {
	API_GET_ALL_CANCEL_REASON_UNTAKEN,
	API_GET_ALL_CANCEL_REASON_ADDED,
	API_ADMIN_GET_ALL_CANCEL_REASON,
	API_ADMIN_GET_CANCEL_REASON,
	ADMIN_INIT_NEW_CANCEL_REASON,
	ADMIN_RESET_FOCUS_CANCEL_REASON,
	API_ADMIN_POST_CANCEL_REASON,
	API_ADMIN_PATCH_CANCEL_REASON,
	API_ADMIN_DELETE_CANCEL_REASON,
	API_ADMIN_GET_CANCEL_REASON_GROUPS,
	API_GET_ALL_CANCEL_REASON_NATURE,
} from "actions/cancelReason";

export function getAllCancelUntakenReasons() {
	return {
		type: API_GET_ALL_CANCEL_REASON_UNTAKEN,
		payload: {
			request: {
				url: `/cancelReasons/untaken`,
			},
		},
	};
}

export function getAllCancelAddedReasons() {
	return {
		type: API_GET_ALL_CANCEL_REASON_ADDED,
		payload: {
			request: {
				url: `/cancelReasons/added`,
			},
		},
	};
}

export function getAllCancelNatureReasons() {
	return {
		type: API_GET_ALL_CANCEL_REASON_NATURE,
		payload: {
			request: {
				url: `/cancelReasons/nature`,
			},
		},
	};
}

export function adminGetAllCancelReasons() {
	return {
		type: API_ADMIN_GET_ALL_CANCEL_REASON,
		payload: {
			request: {
				url: `/admin/cancelReasons`,
			},
		},
	};
}

export function adminGetCancelReason(cancelReason) {
	return {
		type: API_ADMIN_GET_CANCEL_REASON,
		payload: {
			request: {
				url: `/admin/cancelReasons/${cancelReason.id}`,
			},
		},
	};
}

export function adminPostCancelReason(cancelReason) {
	return {
		type: API_ADMIN_POST_CANCEL_REASON,
		payload: {
			request: {
				url: `/admin/cancelReasons`,
				method: "POST",
				data: cancelReason,
			},
		},
	};
}

export function adminPatchCancelReason(cancelReason) {
	return {
		type: API_ADMIN_PATCH_CANCEL_REASON,
		payload: {
			request: {
				url: `/admin/cancelReasons/${cancelReason.id}`,
				method: "PATCH",
				data: cancelReason,
			},
		},
	};
}

export function adminDeleteCancelReason(cancelReason) {
	return {
		type: API_ADMIN_DELETE_CANCEL_REASON,
		payload: {
			request: {
				url: `/admin/cancelReasons/${cancelReason.id}`,
				method: "DELETE",
			},
		},
	};
}

export function adminGetCancelReasonGroups() {
	return {
		type: API_ADMIN_GET_CANCEL_REASON_GROUPS,
		payload: {
			request: {
				url: `/admin/cancelReasons/groups`,
			},
		},
	};
}

export function initNewCancelReason() {
	return {
		type: ADMIN_INIT_NEW_CANCEL_REASON,
	};
}

export function resetFocusCancelReason() {
	return {
		type: ADMIN_RESET_FOCUS_CANCEL_REASON,
	};
}
